import { useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { Compass, ArrowRight, Zap, Lock, UserRound } from "lucide-react";
import { EASE } from "../lib/motion";

export const StartCard = () => {
  const navigate = useNavigate();
  const reduce = useReducedMotion();
  return (
    <motion.div
      className="evc-card-rail"
      initial={{ opacity: 0, ...(reduce ? {} : { x: 16 }) }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, delay: 0.4, ease: EASE }}
    >
      <div className="evc-card" data-testid="evc-start-card">
        <span className="evc-card-kicker">
          <Compass size={13} strokeWidth={2.2} /> Maturity diagnostic
        </span>
        <h2 className="evc-card-title">Find out where your IT spend really stands</h2>
        <p className="evc-card-sub">
          Start with the eight dimensions of modern ITFM, then pick your path - a free quick check,
          the full diagnostic by access code, or the full diagnostic read one-on-one with an EVC
          expert. Either way, you'll see how defensible your spend is today and how close you are to
          value-level conversations with the business.
        </p>

        <ul className="evc-start-list">
          <li><Zap size={16} /> <span><b>Quick check</b> - 8 questions, 5-10 min, free, no code</span></li>
          <li><Lock size={16} /> <span><b>Full diagnostic</b> - 56 questions, by access code</span></li>
          <li><UserRound size={16} /> <span><b>Full diagnostic + expert read</b> - self-service assessment plus expert reading, from &euro;2,000</span></li>
        </ul>

        <button className="evc-btn" onClick={() => navigate("/start")} data-testid="evc-start-btn">
          Continue <ArrowRight size={17} />
        </button>

        <div className="evc-trust">
          <span>
            Next you'll explore the eight dimensions we measure - then choose your path. The quick
            check is completely free.
          </span>
        </div>
      </div>
    </motion.div>
  );
};
